<template>
    <textarea class="form-control"></textarea>
</template>
<script>
    import '@/assets/vendors/summernote/summernote-bs4.css'
    import '@/assets/vendors/summernote/summernote-bs4.js'
    import { bus } from '../main'
    export default{
        name: 'summernote',
        props : {
            model: {
                required: true
            },
            height: {
                type: String,
                default: '150'
            }
        },
        methods :{
            setup (description) {
                $(this.$el).summernote("code", description)
            },
        },

        mounted() {
            let config = {
                height: this.height,
                toolbar: [
                    ['style', ['style']],
                    ['font', ['bold', 'underline', 'clear', 'fontsize']],
                    ['fontname', ['fontname']],
                    ['color', ['color']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['table', ['table']],
                    ['insert', ['link', 'picture', 'video']],
                    ['view', ['fullscreen', 'codeview', 'help', 'undo', 'redo']],
                ],
                followingToolbar: false,
                dialogsInBody: true,
                dialogsFade: false
            }
            let vm = this
            config.callbacks = {
                onInit: function () {
                    $(vm.$el).summernote('code', vm.model);
                },
                onChange: function () {
                    vm.$emit('update:model', $(vm.$el).summernote('code'))
                },
                onPaste: function (e) {
                    var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');

                    e.preventDefault();

                    // Firefox fix
                    setTimeout(function () {
                        document.execCommand('insertText', false, bufferText);
                    }, 10);
                }
            }

            bus.$on('updateText', (data)=>{
                $(vm.$el).summernote("code", data)
            })

            $(this.$el).summernote(config)
        }
    }
</script>